import { useGenericWalletIcon } from "hooks/useGenericWalletIcon";
import { getIsUserConnected } from "utils/userUtils";
import WalletUnconnectedIcon from "../../../../img/trade-history/wallet-unconnected.svg?react";
import { GlobalStore } from "../../../../store/global/GlobalStore";
import { ProfileIconImage } from "./elements/ProfileIconImage";

export interface ProfileIconProps {
  borderRadius?: number | string;
  size?: number;
  withBackground?: boolean;
}

export const ProfileIcon: React.FC<ProfileIconProps> = ({
  size = 31,
  borderRadius = 14,
  withBackground = false,
}) => {
  const avatar = GlobalStore.useState(s => s.ensAvatar);
  const zerionNft = GlobalStore.useState(s => s.zerionNft);
  const GenericWalletIcon = useGenericWalletIcon();

  if (!getIsUserConnected()) {
    return <WalletUnconnectedIcon width={size} height={size} />;
  }

  if (avatar) {
    return (
      <ProfileIconImage borderRadius={borderRadius} src={avatar} size={size} alt={"ENS Avatar"} />
    );
  }

  if (zerionNft) {
    return (
      <ProfileIconImage
        borderRadius={borderRadius}
        src={zerionNft}
        size={size}
        alt={"Zerion NFT"}
      />
    );
  }

  return <GenericWalletIcon width={size} height={size} css={borderRadius} />;
};
